import { useMemo } from "react";

import { handleGenerateBrandUrl } from "@faire/retailer/components/SearchProducts/utils";
import { ILeanProductTile } from "@faire/retailer/features/MarketplaceItems/MarketplaceProduct/LeanProtos/ILeanProductTile";
import { useSearchPageProductSearchString } from "@faire/retailer/views/search-v2/SearchPageQueryParams/useSearchPageProductSearchString";

export interface BrandUrlParameters {
  productToken: string | undefined;
  brandToken: string | undefined;
  impressionId: string | undefined;
}

export const brandUrlParametersILeanProductTileAdapter = (
  productTile: ILeanProductTile
): BrandUrlParameters => {
  return {
    productToken: productTile.product?.token,
    brandToken: productTile.product?.brand_token,
    impressionId: productTile.product?.impression_id,
  };
};

//TODO: we may need all parameters in other places using onBrandClick, see MarkeplaceProduct.tsx
export const useGenerateBrandUrlFn = (params: BrandUrlParameters) => {
  const queryString = useSearchPageProductSearchString();

  return useMemo(
    () => handleGenerateBrandUrl(queryString, params),
    [queryString, params]
  );
};
